import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=32f3dcc5&"
import script from "./inputForm.js?vue&type=script&lang=js&"
export * from "./inputForm.js?vue&type=script&lang=js&"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=32f3dcc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports